import React, { useState, useMemo } from "react";
import "../Home/theme.css"; // Import the CSS file

const Luvih1 = "/assets/Images/cat1_29.jpg";
const Luvih2 = "/assets/Images/cat1_30.jpg";
const Infusion = "/assets/Images/ExportLam-E-Catalogue-Sept-2024-9_1.jpg";
const Laminature = "/assets/Images/ExportLam-E-Catalogue-Sept-2024-9_2.jpg";
const GlossLaminate = "/assets/Images/ExportLam-E-Catalogue-Sept-2024-9_3.jpg";
const GlossLaminate2 = "/assets/Images/ExportLam-E-Catalogue-Sept-2024-9_4.jpg";
const GlossLaminate3 = "/assets/Images/ExportLam-E-Catalogue-Sept-2024-9_5.jpg";
const Unicolorlaminaate = "/assets/Images/cat1_01.jpg";
const Metalam = "/assets/Images/cat1_02.jpg";
const CONTEMPORARYART = "/assets/Images/cat1_03.jpg";
const PROMINENTWOODSTRUCTURES = "/assets/Images/cat1_04.jpg";
const PROMINENTWOODSTRUCTURES2 = "/assets/Images/cat1_05.jpg";
const PROMINENTWOODSTRUCTURES3 = "/assets/Images/cat1_06.jpg";
const PROMINENTWOODSTRUCTURES4 = "/assets/Images/cat1_07.jpg";
const PROMINENTWOODSTRUCTURES5 = "/assets/Images/cat1_08.jpg";
const MINIMALWOODSTRUCTURES = "/assets/Images/cat1_09.jpg";
const MINIMALWOODSTRUCTURES2 = "/assets/Images/cat1_10.jpg";
const MINIMALWOODSTRUCTURES3 = "/assets/Images/cat1_11.jpg";
const VERTICALWOODSTRUCTURES = "/assets/Images/cat1_12.jpg";
const VERTICALWOODSTRUCTURES2 = "/assets/Images/cat1_13.jpg";
const VERTICALWOODSTRUCTURES3 = "/assets/Images/cat1_14.jpg";
const VERTICALWOODSTRUCTURES4 = "/assets/Images/cat1_15.jpg";
const VERTICALWOODSTRUCTURES5 = "/assets/Images/cat1_16.jpg";
const VERTICALWOODSTRUCTURES6 = "/assets/Images/cat1_17.jpg";
const HORIZONTALWOODSTRUCTURES = "/assets/Images/cat1_18.jpg";
const SAWCUTS = "/assets/Images/cat1_19.jpg";
const SAWCUTS2 = "/assets/Images/cat1_20.jpg";
const patterns = "/assets/Images/cat1_21.jpg";
const pattern2 = "/assets/Images/cat1_22.jpg";
const pattern3 = "/assets/Images/cat1_23.jpg";
const stones = "/assets/Images/cat1_24.jpg";
const stone2 = "/assets/Images/cat1_25.jpg";
const stone3 = "/assets/Images/cat1_26.jpg";
const SOLIDS = "/assets/Images/cat1_27.jpg";
const solids2 = "/assets/Images/cat1_28.jpg";
const OrnaMatte = "/assets/Images/Ornamatte-brochure-3[1]_1.jpg";
const OrnaMatte2 = "/assets/Images/Ornamatte-brochure-3[1]_2.jpg";
const OrnaMatte3 = "/assets/Images/Ornamatte-brochure-3[1]_3.jpg";
const OrnaMatte4 = "/assets/Images/Ornamatte-brochure-3[1]_4.jpg";

const products = [
  { id: 36, name: "ORNAMATTE", category: "ORNAMATTE", img: OrnaMatte },
  { id: 1, name: "LUVIH", category: "LUVIH", img: Luvih1 },
  { id: 2, name: "LUVIH", category: "LUVIH", img: Luvih2 },
  { id: 37, name: "ORNAMATTE", category: "ORNAMATTE", img: OrnaMatte2 },
  { id: 38, name: "ORNAMATTE", category: "ORNAMATTE", img: OrnaMatte3 },
  { id: 39, name: "ORNAMATTE", category: "ORNAMATTE", img: OrnaMatte4 },
  { id: 3, name: "INFUSION", category: "INFUSION", img: Infusion },
  { id: 4, name: "LAMINATURE", category: "LAMINATURE", img: Laminature },
  { id: 5, name: "GLOSS LAMINATES", category: "GLOSS LAMINATES", img: GlossLaminate },
  { id: 6, name: "GLOSS LAMINATES", category: "GLOSS LAMINATES", img: GlossLaminate2 },
  { id: 7, name: "GLOSS LAMINATES", category: "GLOSS LAMINATES", img: GlossLaminate3 },
  { id: 8, name: "UNI COLORLAMINATE", category: "UNI COLORLAMINATE", img: Unicolorlaminaate },
  { id: 9, name: "METALAM", category: "METALAM", img: Metalam },
  { id: 10, name: "CONTEMPORARY ART", category: "CONTEMPORARY ART", img: CONTEMPORARYART },
  { id: 11, name: "PROMINENT WOOD STRUCTURES", category: "PROMINENT WOOD STRUCTURES", img: PROMINENTWOODSTRUCTURES },
  { id: 12, name: "PROMINENT WOOD STRUCTURES", category: "PROMINENT WOOD STRUCTURES", img: PROMINENTWOODSTRUCTURES2 },
  { id: 13, name: "PROMINENT WOOD STRUCTURES", category: "PROMINENT WOOD STRUCTURES", img: PROMINENTWOODSTRUCTURES3 },
  { id: 14, name: "PROMINENT WOOD STRUCTURES", category: "PROMINENT WOOD STRUCTURES", img: PROMINENTWOODSTRUCTURES4 },
  { id: 15, name: "PROMINENT WOOD STRUCTURES", category: "PROMINENT WOOD STRUCTURES", img: PROMINENTWOODSTRUCTURES5 },
  { id: 16, name: "MINIMAL WOOD STRUCTURES", category: "MINIMAL WOOD STRUCTURES", img: MINIMALWOODSTRUCTURES },
  { id: 17, name: "MINIMAL WOOD STRUCTURES", category: "MINIMAL WOOD STRUCTURES", img: MINIMALWOODSTRUCTURES2 },
  { id: 18, name: "MINIMAL WOOD STRUCTURES", category: "MINIMAL WOOD STRUCTURES", img: MINIMALWOODSTRUCTURES3 },
  { id: 19, name: "VERTICAL WOOD STRUCTURES", category: "VERTICAL WOOD STRUCTURES", img: VERTICALWOODSTRUCTURES },
  { id: 20, name: "VERTICAL WOOD STRUCTURES", category: "VERTICAL WOOD STRUCTURES", img: VERTICALWOODSTRUCTURES2 },
  { id: 21, name: "VERTICAL WOOD STRUCTURES", category: "VERTICAL WOOD STRUCTURES", img: VERTICALWOODSTRUCTURES3 },
  { id: 22, name: "VERTICAL WOOD STRUCTURES", category: "VERTICAL WOOD STRUCTURES", img: VERTICALWOODSTRUCTURES4 },
  { id: 23, name: "VERTICAL WOOD STRUCTURES", category: "VERTICAL WOOD STRUCTURES", img: VERTICALWOODSTRUCTURES5 },
  { id: 24, name: "VERTICAL WOOD STRUCTURES", category: "VERTICAL WOOD STRUCTURES", img: VERTICALWOODSTRUCTURES6 },
  { id: 25, name: "HORIZONTAL WOOD STRUCTURES", category: "HORIZONTAL WOOD STRUCTURES", img: HORIZONTALWOODSTRUCTURES },
  { id: 26, name: "SAWCUTS", category: "SAWCUTS", img: SAWCUTS },
  { id: 27, name: "SAWCUTS", category: "SAWCUTS", img: SAWCUTS2 },
  { id: 28, name: "PATTERNS", category: "PATTERNS", img: patterns },
  { id: 29, name: "PATTERNS", category: "PATTERNS", img: pattern2 },
  { id: 30, name: "PATTERNS", category: "PATTERNS", img: pattern3 },
  { id: 31, name: "STONES", category: "STONES", img: stones },
  { id: 32, name: "STONES", category: "STONES", img: stone2 },
  { id: 33, name: "STONES", category: "STONES", img: stone3 },
  { id: 34, name: "SOLIDS", category: "SOLIDS", img: SOLIDS },
  { id: 35, name: "SOLIDS", category: "SOLIDS", img: solids2 },
];

export default function EcommerceFilter() {
  const [search, setSearch] = useState("");
  const [fullscreenProduct, setFullscreenProduct] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [singleSelected, setSingleSelected] = useState(null);

  const categories = useMemo(() => [...new Set(products.map((p) => p.category))], []);

  const handleCategoryClick = (category) => {
    setSingleSelected((prev) => (prev === category ? null : category));
    setSidebarOpen(false);
  };

  const clearCategory = () => setSingleSelected(null);

  const filteredProducts = products.filter((p) => {
    const matchesSearch = p.name.toLowerCase().includes(search.toLowerCase());
    const matchesSingle = singleSelected === null || p.category === singleSelected;
    return matchesSearch && matchesSingle;
  });

  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      {/* Mobile Menu */}
      <button
        className="md:hidden p-4 text-white fixed top-20 left-4 z-40 rounded-lg shadow-lg"
        style={{
          backgroundColor: "var(--color-primary-500)",
        }}
        onClick={() => setSidebarOpen(true)}
      >
        ☰
      </button>

      {/* Sidebar */}
      <div
        className={`fixed top-[75px] left-0 h-full w-64 text-white p-6 shadow-lg transform transition-transform duration-300 z-40
        ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0`}
        style={{
          backgroundColor: "var(--color-primary-500)",
        }}
      >
        <button
          className="absolute top-4 right-4 text-2xl font-bold md:hidden"
          onClick={() => setSidebarOpen(false)}
          style={{ color: "var(--color-white)" }}
        >
          ✕
        </button>

        <h2 className="text-4xl font-extrabold mb-6 text-center md:text-left tracking-wide bell-mt-primary" style={{ color: "var(--color-white)" }}>
          Styles
        </h2>

        <input
          type="text"
          placeholder="🔍 Search product..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full border text-black p-2 rounded-lg mb-6 focus:outline-none focus:ring-2 inter-secondary"
          style={{
            borderColor: "var(--border-light)",
          }}
        />

        <div className="space-y-3">
          {categories.map((category) => (
            <span
              key={category}
              onClick={() => handleCategoryClick(category)}
              className={`block cursor-pointer font-medium text-base sm:text-sm md:text-sm lg:text-lg truncate px-1 transition inter-secondary ${
                singleSelected === category
                  ? "font-bold underline"
                  : ""
              }`}
              style={{
                color: singleSelected === category ? "var(--color-accent-500)" : "var(--color-white)",
              }}
            >
              {category}
            </span>
          ))}
        </div>
      </div>

      {/* Products */}
      <div className="flex-1 md:ml-64 p-8 overflow-y-auto" style={{ backgroundColor: "var(--color-gray-50)" }}>
        <h1 className="text-5xl md:text-7xl font-semibold text-center mb-6 p-5 tracking-wide bell-mt-primary" style={{ color: "var(--color-primary-500)" }}>
          Our Brochure
        </h1>

        {singleSelected && (
          <div className="flex justify-center mb-6">
            <div 
              className="flex items-center gap-2 px-4 py-2 rounded-full shadow-md inter-secondary"
              style={{
                backgroundColor: "var(--color-primary-100)",
                color: "var(--color-primary-700)",
              }}
            >
              <span className="font-bold">{singleSelected}</span>
              <button
                onClick={clearCategory}
                className="text-lg font-bold transition"
                style={{ color: "var(--color-primary-700)" }}
              >
                ✕
              </button>
            </div>
          </div>
        )}

        {filteredProducts.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 place-items-center">
            {filteredProducts.map((p) => (
              <div
                key={p.id}
                className={`w-full md:w-[75%] cursor-pointer flex flex-col items-center bg-white rounded-xl shadow-lg transition transform hover:-translate-y-1 overflow-hidden mx-auto hover:shadow-2xl`}
                style={{
                  backgroundColor: "var(--color-white)",
                  boxShadow: p.id === 36 ? "0 0 0 4px var(--color-primary-500), 0 20px 25px -5px rgba(0,0,0,0.1)" : "var(--shadow-medium)",
                }}
                onClick={() => setFullscreenProduct(p)}
              >
                <img
                  src={p.img}
                  alt={p.name}
                  loading="lazy"
                  className="w-full h-auto max-h-[75vh] object-contain rounded-md"
                />
                <p
                  className={`text-xl font-bold py-4 text-center bell-mt-primary`}
                  style={{
                    color: p.id === 36 ? "var(--color-primary-600)" : "var(--color-gray-900)",
                  }}
                >
                  {p.name}
                </p>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-lg text-center pt-20 inter-secondary" style={{ color: "var(--color-gray-600)" }}>No products found</p>
        )}
      </div>

      {/* Modal */}
      {fullscreenProduct && (
        <div className="fixed inset-0 bg-black bg-opacity-90 flex flex-col items-center justify-center z-50">
          <button
            className="absolute top-6 right-6 text-4xl font-bold transition"
            style={{ color: "var(--color-white)" }}
            onClick={() => setFullscreenProduct(null)}
          >
            ✕
          </button>
          <img
            src={fullscreenProduct.img}
            alt={fullscreenProduct.name}
            loading="lazy"
            className="max-h-[85%] max-w-[90%] object-contain rounded-xl shadow-xl"
          />
          <p className="text-3xl font-semibold mt-6 bell-mt-primary" style={{ color: "var(--color-primary-500)" }}>
            {fullscreenProduct.name}
          </p>
        </div>
      )}
    </div>
  );
}